import axios from 'axios';

const TOKEN_KEY = 'losa0_admin_token';

export const getAuthToken = () => {
  return (
    typeof window !== 'undefined' &&
    (window.sessionStorage.getItem(TOKEN_KEY) || window.localStorage.getItem(TOKEN_KEY))
  );
};

export const setSession = (token: string, remember = true) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  const storage = typeof window !== 'undefined' && (remember ? window.localStorage : window.sessionStorage);
  return storage && storage.setItem(TOKEN_KEY, token);
};

export const resetSession = () => setSession('');
